





























































import { Component, Mixins, Prop } from "vue-property-decorator";
import {
  NewDocumentEditorMixin,
} from "./mixins";
import { PatientFindDialogController } from "../../patient/dialogs";
import NewDocumentFormatSelectorDialog from "../dialogs/NewDocumentFormatSelectorDialog.vue";
import DocumentEditor from "../editor/DocumentEditor.vue";
import LoadedDocumentPreprocessor from "./LoadedDocumentPreprocessor.vue";
import { EditingDocument } from "../editor";

@Component({
  components: {
    DocumentEditor,
    PatientFindDialogController,
    NewDocumentFormatSelectorDialog,
    LoadedDocumentPreprocessor,
  },
})
export default class NewDocumentEditor extends Mixins(NewDocumentEditorMixin) {
  $refs!: {
    documentEditor: DocumentEditor
  };

  @Prop()
  systemKey: string;

  @Prop()
  linkKey: string;

  @Prop({ default: false })
  shouldValidateExistingLinkedDocument: boolean;

  updateEditingDocument(delegate: (editingDocument: EditingDocument) => void): void {
    this.$refs.documentEditor.updateEditingDocument(delegate);
  }

  async registerDocument(isTemporary: boolean): Promise<number> {
    return this.$refs.documentEditor.registerDocument(isTemporary);
  }

  async cancelEditing(): Promise<void> {
    this.$logger.debug("文書編集中止要求");
    await this.$refs.documentEditor.deleteWriteToken();
  }
}
